// extracted by mini-css-extract-plugin
export default {"storeLink":"StoreButton_storeLink__NPVIv","storeBadge":"StoreButton_storeBadge__vvIyo"};